module.exports = __webpack_public_path__ + "img/ali-pay-use.c6d442ad.png";